export const setThemeClass = (className: "light" | "dark") => {
  const classNameToRemove = className === "light" ? "dark" : "light"
  document.documentElement.classList.add(className)
  document.documentElement.classList.remove(classNameToRemove)
}
